import endpoints, { axios } from "../../config/api";

async function getCommercialTemplatesFolder() {
  return await (await axios.get(endpoints.newfolders.commercialTemplates)).data;
}

export default getCommercialTemplatesFolder;
